import { render, staticRenderFns } from "./SeriesAssignmentContainer.vue?vue&type=template&id=1d783a47&scoped=true&"
import script from "./SeriesAssignmentContainer.vue?vue&type=script&lang=js&"
export * from "./SeriesAssignmentContainer.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/assignment_dates.css?vue&type=style&index=0&id=1d783a47&prod&scoped=true&lang=css&"
import style1 from "./SeriesAssignmentContainer.vue?vue&type=style&index=1&id=1d783a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d783a47",
  null
  
)

export default component.exports